import { ModalService } from 'src/app/modal/modal.service';
import { ComponentFactoryResolver, Injectable } from '@angular/core';
import { DynamicFormContainer } from 'src/app/components/edit-form/dynamic-form.container';
import { EditFormsResourceService } from './application-resources/edit-forms.service';
import { getDataUrl } from 'src/app/helpers/get-data-url';
import { SelectEditField } from 'src/app/components/edit-form/models/edit-fields';

@Injectable({ providedIn: 'root' })
export class EditFormService {
  constructor(
    private modalService: ModalService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private editFormsResourceService: EditFormsResourceService
  ) {}

  openEditForm(editFormId: string, keyValuePairs?: { key: string; value: any }[]) {
    
    const editFormOptions = JSON.parse(JSON.stringify(this.editFormsResourceService.getResource(editFormId).data));

    let parameters = {};
    if (keyValuePairs && keyValuePairs.length > 0)
      parameters = keyValuePairs.reduce((prevVal, currVal, currIndex) => {
        return {
          ...prevVal,
          [currVal.key]: currVal.value,
        };
      }, {});

    editFormOptions.fields.forEach((field) => {
      if (
        field.defaultValue &&
        typeof field.defaultValue === 'string' &&
        field.defaultValue.startsWith('{')
      ) {
        const defaultValueKey = field.defaultValue
          .replace('{', '')
          .replace('}', '');
        const replaceValue = parameters[defaultValueKey];
        if (replaceValue) field.defaultValue = replaceValue;
      }
    });

    if (editFormOptions.getFormUrl)
      editFormOptions.getFormUrl = getDataUrl(
        parameters,
        editFormOptions.getFormUrl
      );

    if (editFormOptions.saveFormUrl)
      editFormOptions.saveFormUrl = getDataUrl(
        parameters,
        editFormOptions.saveFormUrl
      );

    if (editFormOptions.deleteFormUrl)
      editFormOptions.deleteFormUrl = getDataUrl(
        parameters,
        editFormOptions.deleteFormUrl
      );

    editFormOptions.fields.forEach(field => {
        const selectField = field as SelectEditField;
        if(selectField?.optionsUrl) {
          const modifiedOptionsUrl = getDataUrl(parameters, selectField.optionsUrl);
          selectField.optionsUrl = modifiedOptionsUrl;
        }
      });

    this.modalService.open({
      componentFactory: this.componentFactoryResolver.resolveComponentFactory(
        DynamicFormContainer
      ),
      onInit: (component) => {
        component.dynamicFormOptions = editFormOptions;
      },
    });
  }
}
